import { createI18n } from 'vue-i18n'

import langEnUs from '../lang/en_US.json'
import langTHth from '../lang/th_TH.json'
import { localRead, localSave } from '@/store/lang'

const navLang = navigator.language
const localLang = (navLang === 'th-TH') ? navLang : false
let lang = localRead('local') || localLang || 'th-TH'
lang = lang.split('-')[0];

const messages = {
  en: langEnUs,
  th: langTHth
}

const i18n = new createI18n({
  locale: lang,
  messages,
  silentTranslationWarn: true
});

/**
 * สลับภาษาทั้งระบบ
 *
 * ชื่อสินค้า/หมวด/ตัวเลือก มาจาก API เป็นคู่ (name + name_en) แล้ว helper `$ln`
 * เลือกตอน render — เปลี่ยน locale จึงอัปเดตทันทีแบบ reactive
 * ไม่ต้อง refetch ไม่ต้อง reload และไม่เสีย state ที่ค้างอยู่บนหน้า
 */
export function setLocale(lang) {
  const locale = String(lang || 'th').split('-')[0]

  localSave('local', locale)
  i18n.global.locale = locale
}

export default i18n
